import type { FaireProductEntity } from "../../entity_types/product";

export const p_m6zfg3dbw7: FaireProductEntity = {
  token: "p_m6zfg3dbw7",
  type: "product",
  name: "Navy Stripes Thank You Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/cd1ae0c2b58f4edddbd58801d2598ee904837c6e99116a57f370c5c4a618d215.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2561d557d9d1004aa9486ac3cbf2640fde3947328e4627815c4208dcac92bcb0.jpeg",
    "https://cdn.faire.com/fastly/a14c88521ab61193fb32f43e15d1bc24ea77da02165d98a087e21164c002c030.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:45.144Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
